<script>
import Vue from 'vue'
import countryFlagEmoji from 'country-flag-emoji'
import Flags from '@/assets/images/flags'
import { isWindows } from '@/utils/os'

const COUNTRIES = countryFlagEmoji.list

export default Vue.extend({
    name: 'FlagCellRenderer',
    data () {
        return {
            country: false,
        }
    },
    computed: {
        normalizeCountries () {
            const { value } = this.params
            const input = Array.isArray(value) ? value : [value]
            return input.map(name => ({
                label: name,
                meta: this.findCountry(name),
            }))
        },
    },
    methods: {
        getValue () {
            const { value } = this.params
            return value
        },
        findCountry (country) {
            if (!country) return {}
            return COUNTRIES.find(({ name }) => name.toLowerCase() === country.toLowerCase()) || {}
        },
    },
    render (h) {
        return h(
            'div',
            {
                class: 'FlagCellRenderer',
            },
            this.normalizeCountries.map(({ label, meta: { code, emoji } }) => {
                if (!code) return h('span', `${label}`)
                if (isWindows) {
                    return [
                        h('img', {
                            attrs: {
                                src: Flags[code.toLowerCase()], alt: code,
                            },
                        }),
                        h('span', ` ${label}`),
                    ]
                }
                return h('span', `${emoji} ${label}`)
            }),
        )
    },
})
</script>
<style scoped lang="scss">
.FlagCellRenderer {
    span + span {
        margin-left: 8px;
    }
}
</style>
